exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vue-slider-mark-label{font-size:12px;font-weight:400}", ""]);

// exports
